import React, { Fragment, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
const SingleSlider = ({ data: { main_image, product_images } }) => {
  if (!Array.isArray(product_images)) {
    product_images = [{}];
  }
  const initialState = {
    loading: true,
    data: [main_image, ...product_images],
    img: main_image || {},
  };
  const [state, setstate] = useState(initialState);
  //   const renderAlt = i => {
  //     if (alt && Array.isArray(alt) && alt.length > 0) {
  //       return alt[i] ? alt[i] : `${name} رزرو مجموعه ی`;
  //     }
  //     return `مجموعه ${name}`;
  //   };
  return (
    <Fragment>
      <div
        className="col-lg-2 me-2  resg-direct-box"
        style={{ width: "unset" }}
      ></div>

      <div className=" mt-2">
        <img
          src={state?.img?.url}
          //   alt={renderAlt(1)}
          className="main-img"
        />
        <div className="resg-img-card-hover">
          <div className="resg-img-logo"></div>
        </div>
      </div>
      <div className="row justify-content-between text-center pt-2 px-1 ">
        <div className="px-0">
          <Splide
            className=""
            options={{
              direction: "rtl",
              gap: "0.7rem",
              perPage: 6,
              perMove: 1,
              pagination: false,
              arrows: false,
              breakpoints: {
                1400: {
                  perPage: 5,
                },
                576: {
                  perPage: 4,
                },
                450: {
                  perPage: 3,
                },
                370: {
                  perPage: 2,
                },
              },
            }}
          >
            {state.data &&
              state.data.map((item, i) => {
                if (i < 8) {
                  return (
                    item.url && <SplideSlide key={i} className="splide__slide ">
                      <div
                        className=""
                        onClick={() =>
                          setstate({
                            ...state,
                            img: item,
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex flex-wrap mb-1">
                          {/* <div className="resg-direct-img"> */}
                          <img
                            // alt={renderAlt(i)}
                            src={item?.url}
                            className="img-fluid rounded-3"
                            style={{
                              objectFit: "fill",
                              width: "95",
                              height: "62.5px",
                            }}
                          />
                          {/* </div> */}
                        </div>
                      </div>
                    </SplideSlide>
                  );
                }
              })}
          </Splide>
        </div>
      </div>
    </Fragment>
  );
};

export default SingleSlider;
